import type { FC } from 'react';
import { Form, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

export interface WorkOrderHoldDialogProps {
  open: boolean;
  workOrderCode: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}

type HoldFormValues = { reason: string };

export const WorkOrderHoldDialog: FC<WorkOrderHoldDialogProps> = ({
  open,
  workOrderCode,
  loading = false,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation('maintenance');
  const [form] = Form.useForm<HoldFormValues>();

  return (
    <Modal
      open={open}
      title={t('workOrders.kanban.hold.title', { code: workOrderCode })}
      okText={t('workOrders.kanban.hold.confirm')}
      cancelText={t('workOrders.kanban.cancel')}
      confirmLoading={loading}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => {
        void form.validateFields().then((values) => {
          onConfirm(values.reason.trim());
          form.resetFields();
        });
      }}
      destroyOnHidden
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="reason"
          label={t('workOrders.kanban.hold.reason')}
          rules={[
            {
              required: true,
              message: t('workOrders.kanban.hold.reasonRequired'),
            },
          ]}
        >
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
